import * as d3 from '../scripts/lib/d3.js'

const measurements = require('json!./bullet-chart.json')
const measurementsHistory = require('json!./bullet-chart-history.json')

export default Object.keys(measurements).filter(k => !!k).map(k => {
  const _measurements = measurements[k].stations.map(m => {
    m.history = measurementsHistory[m.mstnr]
    m.city = k
    return m
  })
  return {
    name: k,
    plz: measurements[k].plz,
    mVal: d3.max(_measurements.map(d => d.value)),
    measurements: _measurements
  }
}).sort((a, b) => +b.mVal - +a.mVal)



// WEBPACK FOOTER //
// ./src/data/datasets.js